export default __webpack_public_path__ + "static/media/block2.886dbe86.jpg";